// tslint:disable
import { Injector, Component } from "@angular/core";

import {
  CMFormBrowse2Component,
  CMInputConfig,
  CMFormGlobaisComponent,
  CMFormModalComponent,
} from "../../@cmcore/component";
import { ContaPagarReceberEditComponent } from "./conta-pagar-receber-edit.component";
import { ClienteBrowseComponent } from "../cliente/cliente-browse.component";
import { FuncsGlobais } from "../funcs.globais";
import { DuplicataReceberRelatoriosComponent } from "../duplicata-receber-relatorios/duplicata-receber-relatorios.component";
import { ContaContabilBrowseComponent } from "../conta-contabil";
import { FormaPagamentoBrowseComponent } from "../formapagamento";
import { ContaPagarReceberBaixaOutrosComponent } from "../conta-pagar-receber-baixa-outros";
import { PessoaBrowseComponent } from "../pessoa";

@Component({
  selector: "conta-pagar-receber-browse",
  templateUrl:
    "./../../@cmcore/component/cmform/cmform-browse/cmform-browse2.component.html",
  styleUrls: [
    "./../../@cmcore/component/cmform/cmform-browse/cmform-browse2.component.scss",
  ],
})
export class ContaPagarReceberBrowseComponent extends CMFormBrowse2Component {
  valuesOrigem = [];
  tipoDuplicata = [
    { value: "Pagamento", text: "Pagamento"},
    { value: "Recebimento", text: "Recebimento"},
    { value: "Todas"},
  ]

  setValuesOrigem() {
    if (this.paramEmpresa.modoOperacao === "Nivel1"){
    this.valuesOrigem = [
      { value: "PreVenda", text: "Pré-Venda" },
      { value: "NFe", text: "NF-e" },
      { value: "CFe", text: "CF-e" },
      { value: "Lote", text: "Lote" },
      { value: "CupomDesconto", text: "Cupom de Desconto" },
      { value: "Todas" },
    ];
    }else {this.valuesOrigem = [
      { value: "PreVenda", text: "Pré-Venda" },
      { value: "NFe", text: "NF-e" },
      { value: "CFe", text: "CF-e" },
      { value: "Lote", text: "Lote" },
      { value: "CupomDesconto", text: "Cupom de Desconto" },
      { value: "NFCe", text: "NFC-e" },
      { value: 'NFeRecebimento', text: 'NF-e de Recebimento'},
      { value: "Cadastro", text: "Cadastro" },
      { value: "Todas" },
    ];

    }

  }

  constructor(_injector: Injector) {
    super(_injector);
    this.setValuesOrigem();
    this.controllerName = "contapagarreceber";
    this.formEditComponent = ContaPagarReceberEditComponent;
    this.showPrintButton = true;
    this.buttonsExtra = 3;
    this._hideShowFilters = true;
    this.columns = [
        {
            field: "tipoduplicata",
            caption: "Tipo de Documento",
            filter: new CMInputConfig({
                values: this.tipoDuplicata,
            }),
            value: "Todas",
            visible: false
        },
        {
            field: "tipo",
            caption: "Tipo",
        },
      {
        field: "origem",
        caption: "Origem",
        filter: new CMInputConfig({
          values: this.valuesOrigem,
        }),
        value: "Todas",
      },
      { field: "nduplicata", caption: "Documento" },
      { field: "dvenc", caption: "Data de Vencimento" },
      { field: "datacadastro", caption: "Data de Emissão" },
      {
        field: "dataini",
        caption: "Data de Vencimento Inicial",
        visible: false,
        filter: new CMInputConfig({
          mask: "99/99/9999",
        }),
        value: this.firstDateLastMonth(),
      },
      {
        field: "datafim",
        caption: "Data de Vencimento Final",
        visible: false,
        filter: new CMInputConfig({
          mask: "99/99/9999",
        }),
        value: this.lastDateNextMonth(),
      },
      {
        field: "datainiliquidacao",
        caption: "Data de Baixa Inicial",
        visible: false,
        filter: new CMInputConfig({
          mask: "99/99/9999",
        }),
        //value: this.firstDateLastMonth(),
      },
      {
        field: "datafimliquidacao",
        caption: "Data de Baixa Final",
        visible: false,
        filter: new CMInputConfig({
          mask: "99/99/9999",
        }),
        //value: this.lastDateNextMonth(),
      },
      {
        field: "datacadastroini",
        caption: "Data de Emissão Inicial",
        visible: false,
        filter: new CMInputConfig({
          mask: "99/99/9999",
        }),
        //value: this.firstDateLastMonth(),
      },
      {
        field: "datacadastrofim",
        caption: "Data de Emissão Final",
        visible: false,
        filter: new CMInputConfig({
          mask: "99/99/9999",
        }),
        //value: this.lastDateNextMonth(),
      },
      {
        field: "cliente_nome",
        caption: "Destinatário",
        filterField: "destinatario.id",
        filterValue: "destinatario.codigo",
        fieldBottom: "destinatario.nome",
        filter: new CMInputConfig({
          dataType: "integer",
          pesqFunc: (sender) => {
            PessoaBrowseComponent.pesquisa(
              sender,
              this.valuesFilters,
              "Todos",
              "destinatario"
            );
          },
        }),
      },
      {
        field: "nduplicata",
        caption: "Documento",
        visible: false,
        filter: new CMInputConfig({
          maxlength: 60,
        }),
      },
      {field: 'contacontabil_descricao', caption: 'Conta Contábil',
       filterField: 'contacontabil.id',
       filterValue: 'contacontabil.codigo',
       fieldBottom: 'contacontabil.descricao',
       filter: new CMInputConfig({
         dataType: "integer",
         pesqFunc: (sender) => {
           ContaContabilBrowseComponent.pesquisa(sender, this.valuesFilters, "Conta Contábil");
         },
       })
      },
      {
        field: "formapagamento_descricao",
        caption: "Forma de Pagamento",
        width: 250,
        filterField: "formapagamento.id",
        filterValue: 'formapagamento.codigo',
        fieldBottom: "formapagamento.descricao",
        filter: new CMInputConfig({
          dataType: "integer",
          pesqFunc: (sender) => {
            console.log('this.valuesFilers: ', this.valuesFilters);
            FormaPagamentoBrowseComponent.pesquisa("contapagarreceber", sender, this.valuesFilters);
          },
        }),
      },
      {
        field: "status",
        caption: "Status",
        visible: false,
        filter: new CMInputConfig({
          values: [
            { value: "Abertas" },
            { value: "Baixadas" },
            { value: "Todas" },
          ],
        }),
        value: "Abertas",
      },
      { field: "valor", caption: "Valor" },
      { field: "vsaldo", caption: "Saldo" },
      { field: "databaixa", caption: "Data de baixa" },
      { field: "geracao", caption: "Geração Boleto" },
      { field: "tipocontapagarreceber", filter: true, value: "boleto", visible:false, filterVisible: false },
    ];
    if (DuplicataReceberRelatoriosComponent.getRelatorioCustomizados().length === 0){
      this.getRelatoriosCustomizados();
    }
    console.log(DuplicataReceberRelatoriosComponent.getRelatorioCustomizados());
  }

  
  _print() {
    console.log('method override')
    if (this.diretoImprimir) this.print();
  }
  
  print() {
    console.log('method overriden');
    if (DuplicataReceberRelatoriosComponent.getRelatorioCustomizados().length > 0){
      this.openFormRelatoriosDuplicataReceber();
    }
    else{
      let data = { id: this.grid.fieldByName("id_duplicata") };
      data = this.getDataPrint(data);
      this.showRelat("Print", data, "contapagarreceber");
    }
  }

  
  getRelatoriosCustomizados(){
    this.postSubscribeT<Array<Object>>(
      "/api/cupomdesconto/GetRelatoriosCustomizados",
      JSON.stringify({}),
      (result) => {
        result.forEach(element => {
          if (element['tipo'] === 'DuplicataReceber'){
            DuplicataReceberRelatoriosComponent.addRelatorioCustomizado({value: element['id'], text: element['descricao']});
          }
        });
      },
    );
  }
  
  openFormRelatoriosDuplicataReceber() {
    this.beforeComponent = DuplicataReceberRelatoriosComponent;
    setTimeout(() => {
      CMFormModalComponent.open("formRelatoriosDuplicataReceber");
    }, 100);
  }
  
  openFormContaPagarReceberBaixaOutros() {
    this.beforeComponent = ContaPagarReceberBaixaOutrosComponent;
    setTimeout(() => {
      CMFormModalComponent.open("formBaixaFormaPagamentoOutros");
    }, 100);
  }

  getTitle() {
    return "Contas a Pagar e Receber";
  }
  
  getShowActionRemove() {
    return false;
  }

  baixaTotal() {
    this.postSubscribeT<Array<string>>(
      "/api/contapagarreceber/baixatotal/FuncaoExtra",
      JSON.stringify({ id: this.grid.fieldByName("id_duplicata")}),
      (result) => {
        let result_str = result.pop();
        if (result_str === "ok") {
          CMFormGlobaisComponent.toastSucesso("Documento baixado");
          this.refresh();
          return true;
        } else {
          CMFormGlobaisComponent.toastErro(result_str);
          return false;
        }
      },
      (error) => {
        this.showMessageErrorHTTP("onPage", error);
      }
    );
  }

  geraboleto() {
    this.postSubscribeT<Array<string>>(
      "/api/contapagarreceber/geraboleto/FuncaoExtra",
      JSON.stringify({ id: this.grid.fieldByName("id_duplicata") }),
      (result) => {
        let result_str = result.pop();
        if (result_str === "ok") {
          CMFormGlobaisComponent.toastSucesso("Boleto Gerado");
          this.refresh();
          return true;
        } else {
          CMFormGlobaisComponent.toastErro(result_str);
          return false;
        }
      },
      (error) => {
        this.showMessageErrorHTTP("onPage", error);
      }
    );
  }

  loadDireitoButtonExtra(index: number) {
    if (index === 0) {
      this.getDireitosMenuBrowseButtonsExtra(index, "BaixaTotal");
    } else if (index === 1) {
      this.getDireitosMenuBrowseButtonsExtra(index, "GeraBoleto");
    } else if (index === 2) {
      this.getDireitosMenuBrowseButtonsExtra(index, "ImpressaoDuplicataReduzida");
    }
  }

  buttonsExtraClick(index: number) {
    super.buttonsExtraClick(index);
    if (index === 0) {
        
      console.log(this);
      console.log("this.grid.fieldByName('tpagnfe'): ", this.grid.fieldByName("tpagnfe"));

      if (this.grid.fieldByName("tpagnfe") === "CreditoLoja"){
        this.openFormContaPagarReceberBaixaOutros();
      }
      else {
        CMFormGlobaisComponent.showConfirmation(
          "Baixa total",
          "Deseja realizar a baixa total do documento?",
          () => {
            this.baixaTotal();
          }
        );
      }

    } else if (index === 1) {
      CMFormGlobaisComponent.showConfirmation(
        "Gerar Boleto",
        "Deseja gerar boleto bancário para o documento?",
        () => {
          this.geraboleto();
        }
      );
    } else if (index === 2) {
      
      let data = { id: this.grid.fieldByName("id_duplicata") };
      data = this.getDataPrint(data);
      this.showRelat(
        "/ImpressaoDuplicataReduzida/FuncaoExtra",
        data,
        "contapagarreceber"
      );
    }
  }

  buttonsExtraIcon(index: number) {
    let r: string = "";
    if (index === 0) r = "attach_money";
    else if (index === 1) r = "view_column";
    else if (index === 2) r = "receipt";
    return r;
  }

  buttonsExtraHint(index: number) {
    let r: string = "";
    if (index === 0) r = "Baixa total";
    else if (index === 1) r = "Gerar Boleto";
    else if (index === 2) r = "Imprimir Reduzido";
    return r;
  }

  buttonsExtraVisible(index: number) {
    let r: boolean = super.buttonsExtraVisible(index);
    if (r) {
      let isCurrent: boolean = false;
      if (this.grid) {
        isCurrent = this.grid.isCurrent;
      }
      if (index === 0) r = isCurrent;
      else if (index === 1) r = isCurrent;
      else if (index === 2) r = isCurrent;
    }
    return r;
  }

  get paramEmpresa() {
    return FuncsGlobais.paramEmpresa;
  }
}
